import {Comment} from "../comments/domain";
import {HistoryRecord} from "../history/domain";

export enum Status {
  noContact = "no contact",
  noAnswer = "no answer",
  pending = "pending",
  notInterested = "not interested",
  partner = "partner",
  trial = "trial",
}

export interface Lead {
  id: string
  name: string
  category: string
  status: string
  country: string
  website: string
  email: string
  manager: {
    id: string
    name: string
  }
  additionalEmail: string | null
  socialMedia: string | null
  comments: Comment[]
  history: HistoryRecord[]
}

export type CreateLeadData = Omit<Lead, "id" | "comments" | "history">
